import { useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import Button from 'components/Button/Button';

function CookiePolicyPage() {    
    const navigate = useNavigate();    

    // Add the cookiebot
    useEffect(() => {       
        const script = document.createElement("script");
        script.id = "CookieDeclaration"
        script.src = "https://consent.cookiebot.com/71f1dae0-4e8b-4339-85e2-b285baec57ce/cd.js";
        script.async = true;
        
        const cookiebotContainer = document.getElementById("cookie-declaration-container");
        cookiebotContainer.appendChild(script);
        return () => {
            cookiebotContainer.removeChild(script);
        };
      });

    return (
        <>            
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="d-flex flex-row justify-content-between align-items-start">
                            <h1 className="msds-text-header-1 msds-text-clear-blue mb-10">Cookie Policy</h1>
                            <Button color="secondary" className="mb-4 mt-0" type="button" onClick={() => navigate(-1)}>Back</Button>
                        </div>
                        <div id="cookie-declaration-container"></div>                                                         
                    </div>                    
                </div>
            </div>
        </>
    );
}

export default CookiePolicyPage;